import React from 'react';
import { useHistory } from 'react-router-dom';
import Box from '@material-ui/core/Box';
import Typography from '@material-ui/core/Typography';

import BaseButton from 'features/app/components/BaseButton';
import { dashboardPaths } from 'features/dashboard/routes/paths';
import { useTranslation } from 'hooks/useTranslation';

import { useStyles } from './styles';
import { ReactComponent as FailedTopUpIcon } from 'assets/icons/failed-top-up-icon.svg';
import clsx from "clsx";
import {Grid} from "@material-ui/core";

interface FailedActionProps {
  error?: string;
}

export const FailedAction = ({error} : FailedActionProps) => {
  const { t } = useTranslation('dashboard');
  const { push } = useHistory();
  const classes = useStyles();

  const backToDashboard = () => {
    push(dashboardPaths.static.root);
  };

  return (
    <Box flex={1} display="flex" justifyContent="center" alignItems="center">
      <Box
        flex={1}
        display="flex"
        flexDirection="column"
        justifyContent="center"
        alignItems="center"
        className={classes.modalContainer}
      >
        <Box display="flex" justifyContent="center" alignItems="center" className={classes.planeIconContainer}>
          <FailedTopUpIcon />
        </Box>

        <Grid container justifyContent={"center"}>
          <Typography variant="h3" className={classes.modalTitle}>
            {t('topUp')}
          </Typography>
          <Typography variant="h3" className={clsx(classes.modalTitle, classes.failed)}>
            {t('failed')}
          </Typography>
        </Grid>

        <Typography className={classes.modalError}>
          {error}
        </Typography>
        <BaseButton borderRadius={13} className={classes.backToDashboardBtn} onClick={backToDashboard} variant={"outlined"}>
          {t('backToDashboard')}
        </BaseButton>
      </Box>
    </Box>
  );
};
